export default __webpack_public_path__ + "static/media/ShopX-Logo.5f64982b.png";